<template>
  <b-container fluid>
    <b-row class="mb-5">
      <b-col lg="2">
        <div class="mb-3">
          <b-button
            variant="primary"
            @click="showCreateEditUserModal"
            block
            class="mb-3"
          >
            Nouvel utilisateur
          </b-button>
        </div>
      </b-col>

      <b-col lg="10">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button @click="getAllUsers" class="mr-1">All</b-button>
            <b-button
              :variant="dark ? 'dark' : 'light'"
              @click="dark = !dark"
              class="mr-1"
              ><b-icon :icon="dark ? 'sun' : 'moon'" aria-hidden="true"></b-icon
            ></b-button>
            <!-- <b-button variant="info" @click="stickyHeader">Sticky header</b-button> -->
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          responsive
          :sticky-header="isStickyHeader"
          :dark="dark"
          :filter="filter"
          :items="users"
          :fields="fields"
        >
          <template #cell(actions)="row">
            <b-button
              @click="showDeleteModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="danger"
              block
            >
              Supprimer
            </b-button>
            <b-button
              @click="showEditModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="warning"
              block
            >
              Modifier
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <create-edit-user-modal v-if="isShowUserModal" :user="user"></create-edit-user-modal>
  </b-container>
</template>

<script>
import CreateEditUserModal from "./ModalCreateEditUser.vue";

export default {
  name: "UserManagement",
  data() {
    return {
      users: [],
      user: {},
      windowHeight: window.innerHeight - 120,
      isStickyHeader: window.innerHeight - 120 + "px",
      dark: true,
      isShowUserModal: false,
      filter: "",
      fields: [
        {
          key: "id",
          sortable: true,
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "actions",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        },
        {
          key: "role",
          sortable: true,
        },
        {
          key: "datas",
          sortable: true,
        },
        {
          key: "createdAt",
          sortable: true,
        },
        {
          key: "updatedAt",
          sortable: true,
        },
      ],
    };
  },
  components: {
    CreateEditUserModal,
  },
  mounted() {
    console.log("users component");
    this.getAllUsers();

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-newUser") {
        this.getAllUsers();
        this.isShowUserModal = false;
      }
    });
  },
  methods: {
    getAllUsers() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/adminUsers/all", {
        method: "get",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          // console.log(json);
          // this.users = json.filter((item) => item.email.includes("solaire"));
          this.users = json.filter((item) => !item.email.includes("test"));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteUserById(user) {
      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/adminUsers/deleteUserById",
        {
          method: "delete",
          body: JSON.stringify({
            userId: user.id,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then(() => {
          this.getAllUsers();
        })

        .catch((err) => {
          console.log(err);
        });
    },
    showDeleteModal(user) {
      this.$bvModal
        .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cet utilisateur ?")
        .then((value) => {
          if (value && user.id !== 1) {
            console.log(user);
            this.deleteUserById(user);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    showEditModal(user) {
      this.user = user;
      this.isShowUserModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newUser");
      }, 100);
    },
    showCreateEditUserModal() {
      this.user = null;

      this.isShowUserModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newUser");
      }, 100);
    },
  },
  watch: {},
  computed: {
    style() {
      return {
        top: this.top + "px",
        left: this.left + "px",
      };
    },
  },
};
</script>
<style>
.context-menu {
  position: fixed;
  background: white;
  z-index: 999;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}
</style>
